// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CookieSettings_wrapper__1s6w5"};